import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import React from "react";

import { getResponsiveStylingClassNames } from "@faire/retailer/components/SDUI/__internal__/Styling/responsiveValues";
import {
  ResponsiveSpacingPixels,
  getResponsiveSpacingPixels,
} from "@faire/retailer/components/SDUI/__internal__/Styling/spacing";
import { SDUIComponentInstanceRendererProps } from "@faire/retailer/components/SDUI/__internal__/types";
import * as styles from "@faire/retailer/components/SDUI/ComponentRenderers/Spacer/styles/SDUISpacerRendererStyles.css";

export const SDUISpacerRenderer: React.FC<
  SDUIComponentInstanceRendererProps
> = ({ component }) => {
  const spacerComponent = component.spacer_component;
  if (!spacerComponent) {
    return null;
  }
  const { vertical_spacing, responsive_vertical_spacing, style } =
    spacerComponent;
  const variant = style?.variant;
  const responsiveValues = getResponsiveSpacingPixels(
    vertical_spacing,
    responsive_vertical_spacing
  );
  if (!variant || !responsiveValues.mobileAndAbove) {
    return null;
  }

  return (
    <div
      data-test-id="sdui-spacer"
      className={classNames(
        styles.spacerStyle,
        styles.mobileAndAboveSpacing,
        getResponsiveStylingClassNames(
          responsiveValues,
          ResponsiveVerticalSpacingClassNames
        )
      )}
      style={assignInlineVars({
        [styles.mobileAndAboveHeight]: `${responsiveValues.mobileAndAbove}`,
        [styles.tabletAndAboveHeight]: `${responsiveValues.tabletAndAbove}`,
        [styles.desktopAndAboveHeight]: `${responsiveValues.desktopAndAbove}`,
      })}
    >
      {variant === "HORIZONTAL_LINE" ? (
        <HorizontalLine
          color={
            style?.color !== undefined
              ? getSlateColorToken(style.color)
              : undefined
          }
        />
      ) : null}
    </div>
  );
};

const ResponsiveVerticalSpacingClassNames: Partial<
  Record<keyof ResponsiveSpacingPixels, string>
> = {
  tabletAndAbove: styles.tabletAndAboveSpacing,
  desktopAndAbove: styles.desktopAndAboveSpacing,
};
